import axios from 'axios'
import url from '../urls'

export default {
  add (_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url.VocStudentClozeTestUrl, data)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getByStudentId (_context, studentIdOrParams) {
    const params =
      studentIdOrParams && typeof studentIdOrParams === 'object'
        ? studentIdOrParams
        : { studentId: studentIdOrParams }
    return new Promise((resolve, reject) => {
      axios
        .get(url.VocStudentClozeTestUrl, { params })
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  },

  getById (_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url.VocStudentClozeTestUrl}/${id}`)
        .then((response) => resolve(response))
        .catch((error) => reject(error))
    })
  }
}
